import {atom} from "recoil";

/**
 * 휴가 당겨쓰기 atom
 * @type {(param: SerializableParam) => RecoilState<{NO: string, keyName: *, category: string}>}
 */
export const vacationDayStateAtom = atom({
    key: "vacationDayStateAtom",
    default: true
})